module.exports = __webpack_public_path__ + "static/img/level_1.d487548.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/level_1.png
// module id = HZWJ
// module chunks = 1